import React, { Suspense } from 'react';
import LoadingMessage from '../LoadingMessage/LoadingMessage';

export default ({ component: Component, ...rest }) => (
  <Suspense fallback={<LoadingMessage />}>
    <Component {...rest} />
  </Suspense>
);
